/**
 * Reads admin handoff from URL hash (or query), writes to localStorage, then strips the fragment.
 * Keep in sync with placedrisk-admin `src/utils/adminAuthForClientPortal.ts`.
 */
export function applyAdminAuthFromUrl(): boolean {
  if (typeof window === 'undefined') return false;
  const fromSearch = new URLSearchParams(window.location.search);
  const fromHash = new URLSearchParams(window.location.hash.slice(1));
  const adminToken = fromHash.get('adminToken') ?? fromSearch.get('adminToken');
  const adminUser =
    fromHash.get('adminUser') ??
    fromSearch.get('adminUser') ??
    fromHash.get('user') ??
    fromSearch.get('user');
  if (!adminToken && !adminUser) return false;
  if (adminToken) {
    try {
      localStorage.setItem('accessToken', adminToken);
    } catch {
      // ignore
    }
  }
  if (adminUser) {
    try {
      const decoded = adminUser.includes('%') ? decodeURIComponent(adminUser) : adminUser;
      localStorage.setItem('user', decoded);
    } catch {
      // ignore
    }
  }
  const cleanUrl = window.location.pathname + (window.location.search || '');
  window.history.replaceState(null, '', cleanUrl);
  return true;
}
